// Layout.tsx
import { Box} from "@chakra-ui/react";
import FooterTech from "./FooterTech";



interface PublicLayoutProps {
  children: React.ReactNode;
}



const TechLayout: React.FC<PublicLayoutProps> = ({ children }) => {
  const onLogout = () => {};
  return (
    
    <Box  bg="black" color="white">
      {/* <NavBar isAuthenticated={false} onLogout={onLogout} userInitials={null}  /> */}
      <Box as="main" minH="80vh"  mt="72px" >
        {children} {/* Page content goes here */}
      </Box>
      <FooterTech />
    </Box>
    
  );
};

export default TechLayout;
